module.exports = __webpack_public_path__ + "static/media/exchange.5248ca76.svg";